import React from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';

import { SkeletonContainer } from 'src/app/pages/starterDashboardV2/shared/components';

import { useSharingTools } from '../../../../hooks/useSharingTools';
import type { Platform } from '../../../../shared/constants';
import { SharingToolsCardWrapperVariant1 } from '../../../SharingToolsCardWrapper';

import { PlatformCardSkeleton } from './components/PlatformCardSkeleton';

/**
 * Loading skeleton for RecommendedGroupsCard.
 * Displays placeholder content with shimmer effect while group data is being fetched.
 */
export const RecommendedGroupsCardLoadingVariant1: React.FC<Props> = ({ platform = 'reddit', title, description }) => {
	const PLACEHOLDER_COLOR = 'bg-[#E1DDE9]';

	const { actions } = useSharingTools('petition_dashboard_grow_petition_v1');

	return (
		<SharingToolsCardWrapperVariant1
			title={title}
			description={description}
			primaryActionOnClick={actions.navigateToGroupRecommendations}
		>
			<SkeletonContainer loading>
				<PlatformCardSkeleton
					platform={platform}
					placeholderColor={PLACEHOLDER_COLOR}
					containerHeight={188}
					imageHeight={123}
				/>
			</SkeletonContainer>
		</SharingToolsCardWrapperVariant1>
	);
};

type Props = Readonly<{
	platform?: Platform;
	title?: TranslationKey;
	description?: TranslationKey;
}>;
